import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class SaleDateEarlierThanPreviousAdvanceError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.sale-date.earlier-than-previous-advance');
    }
}
